import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import $ from 'jquery'
import { Div, Input, DatePicker, Select, TextArea, DropDownList } from "../core";
import utilityHelper from '../../helpers/helperUtil'
import {
    updateUserModalAction,
    updateUserAction,
    clearErrorMsgAction
} from '../../redux/actions/UserAction'
import { Constants,MessageText,Storage } from '../../configs'
import { msg } from '../Notifications/MsgBox';
import { async } from "q";
import { getAllOrgUnitsAction } from "../../redux/actions/MasterAction";
import {
    getAllUnitReviewerAction,
    createDeartmentMapAction,
    updateDeartmentMapAction
} from "../../redux/actions/DepartmentMapAction";

class DepartmentMapModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            docType: '',
            departmentMap :{}
        }

        this.handleChange = this.handleChange.bind(this)
        this.saveDepartmentMap = this.saveDepartmentMap.bind(this)
    }

    componentDidMount() {
        const user = Storage.getUser()
        //this.props.getAllOrgUnits()
        this.props.getAllUnitReviewer()
    }

  async componentWillReceiveProps(nextProps) {

        if ((this.state.departmentMap.index !== nextProps.departmapModal.index ||
            this.state.departmentMap.index === "" ||
            (this.state.departmentMap.index !== "" && this.state.departmentMap.item !== nextProps.departmapModal.item))) {

            let departmentMap = nextProps.departmapModal

            if (departmentMap.index !== "") {
                departmentMap.item = this.props.departmapAll[departmentMap.index]
            } else {
                const user = Storage.getUser()
                let localuser = ""
                if (user){
                    localuser =  user.userName
                }
                departmentMap.item = {
                    create_Department: "",
                    create_Department_Name: "",
                    reviewer_Department: "",
                    reviewer_Department_Name: "",
                    createBy: localuser,
                    isActive: true
                }
            }

            let docType = ''

            await this.setState({
                departmentMap: {
                    index: departmentMap.index,
                    item: departmentMap.item
                }
            })
        }

        $(function () {
            window.onComponentDidMount()
        })
    }

    setOrg_Unit(){
        const { org_unit } = this.props
        let result = null
        result = utilityHelper.toSelectList_CombineFields(org_unit,"unitcode", "unitabbr", "unitcode")

        return result
    }

    setUnitReviewer(){
        const { unitreviewerAll } = this.props
        let result = null
        result = utilityHelper.toSelectList_CombineFields(unitreviewerAll,"unit_Code", "unit_Description", "unit_Code")

        return result
    }

    async handleChange(event) {
        // console.log("handleChange", event.target
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        if (valid) {

            if (name === "Active") {
                if (target.checked) {
                    this.setState({
                        departmentMap: {
                            ...this.state.departmentMap,
                            item: {
                                ...this.state.departmentMap.item,
                                ["isActive"]: true
                            }
                        }
                    })
                }
            }
            else if (name === "InActive") {
                if (target.checked) {
                    this.setState({
                        departmentMap: {
                            ...this.state.departmentMap,
                            item: {
                                ...this.state.departmentMap.item,
                                ["isActive"]: false
                            }
                        }
                    })
                }
            }

            if (name === "create_Department") {
                const { org_unit } = this.props
                let unitname = ''
                let objunit = org_unit.find(f => f.unitcode == value)
                unitname = objunit ? objunit.unitabbr : ''

              await this.setState({
                    departmentMap: {
                        ...this.state.departmentMap,
                        item: {
                            ...this.state.departmentMap.item,
                            ['create_Department_Name']: unitname,
                            [name]: value,
                        }
                    }
                })
            }

            if (name === "reviewer_Department") {
                const { unitreviewerAll } = this.props
                let reviewname = ''
                let objunitreviewer = unitreviewerAll.find(f => f.unit_Code == value)
                reviewname = objunitreviewer ? objunitreviewer.unit_Description : ''

               await this.setState({
                    departmentMap: {
                        ...this.state.departmentMap,
                        item: {
                            ...this.state.departmentMap.item,
                            ['reviewer_Department_Name']: reviewname,
                            [name]: value,
                        }
                    }
                })
            }
            
        } else {
            return
        }
    }

    validateDepartmentMapItem() {
        const { departmentMap } = this.state
    
        let msgvalidate = ""
        if(!departmentMap.item.create_Department){
            msgvalidate += "กรุณาระบุ หน่วยงานผู้ใช้ <br/>"
        }
        if(!departmentMap.item.reviewer_Department){
            msgvalidate += "กรุณาระบุ หน่วยงานจัดหา <br/>"
        }

        if (departmentMap.item.create_Department) {
            const { departmapAll } = this.props
            if (departmentMap.index === "") {
                let objdepartment = departmapAll.find(f => f.create_Department == departmentMap.item.create_Department)
                if (objdepartment) {
                    msgvalidate += "ไม่สามารถบันทึกข้อมูลได้ <br/>เนื่องจากพบว่ามีหน่วยงานผู้ใช้นี้แล้วในระบบ"
                }
            }
            else {
                let objdepartment = departmapAll.find(f => f.create_Department == departmentMap.item.create_Department && f.map_ID !== departmentMap.item.map_ID)
                if (objdepartment) {
                    msgvalidate += "ไม่สามารถบันทึกข้อมูลได้ <br/>เนื่องจากพบว่ามีหน่วยงานผู้ใช้นี้แล้วในระบบ"
                }
            }
        }
        
        if(msgvalidate){
            return {error_message: msgvalidate}
        }
        return null
    }

    async saveDepartmentMap() {
        // console.log("saveUser")
        let errors = []
        let _validateUser = this.validateDepartmentMapItem()
        if (_validateUser !== null) {
            errors.push(_validateUser)
        }
        let error_messages = []
        if (errors.length > 0) {
            errors.forEach((error, index) => {
                error_messages.push(error.error_message)
            })
            msg.error(error_messages.join('<br/>'))
        }
        else {
            if (this.state.departmentMap.index === "") {
                msg.showConfirm("Confirm",
                    MessageText.PAGE.DEPARTMENTMAP.POPUP_MSG_CONFIRM_CREATE,
                    async () => {
                        msg.hideConfirm()
                        await this.props.createDeartmentMap(this.state.departmentMap.item)
                        if (this.props.isSuccess) {
                            msg.success(MessageText.PAGE.DEPARTMENTMAP.POPUP_MSG_SUCCESS_CREATE)
                            $(function () {
                                window.onSavePopupDepartmentMap()
                                window.$('#departmentMap').modal('hide')
                            })
                        } else {
                            msg.error(this.props.departmaperrorMsg)
                        }
                    },
                    () => {
                        msg.hideConfirm()
                        console.log("On Cancel")
                    },
                    () => {
                        console.log("On Closed")
                    }
                )

            } else {
                msg.showConfirm(
                    "Confirm",
                    MessageText.PAGE.DEPARTMENTMAP.POPUP_MSG_CONFIRM_UPDATE,
                    async () => {
                        msg.hideConfirm()

                        const user = Storage.getUser()
                        let localuser = ""
                        if (user) {
                            localuser = user.userName
                        }
                        await this.setState({
                            departmentMap: {
                                ...this.state.departmentMap,
                                item: {
                                    ...this.state.departmentMap.item,
                                    ['updateBy']: localuser,
                                }
                            }
                        })

                        await this.props.updateDeartmentMap(this.state.departmentMap.item)
                        if (this.props.isSuccess) {
                            msg.success(MessageText.PAGE.DEPARTMENTMAP.POPUP_MSG_SUCCESS_UPDATE)
                            $(function () {
                                window.onSavePopupDepartmentMap()
                                window.$('#departmentMap').modal('hide')
                            })
                        } else {
                            msg.error(this.props.departmaperrorMsg)
                        }
                    },
                    () => {
                        msg.hideConfirm()
                        console.log("On Cancel")
                    },
                    () => {
                        console.log("On Closed")
                    }
                )
            }
        }
    }

    render() {
        const { departmentMap } = this.state
        const roleAdmin = Storage.getRoleAdmin()

        return (
            <div className="modal fade sp-modal rrs-modal" id="departmentMap" tabIndex={-1} role="dialog" aria-labelledby="userModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="userModalLabel">เพิ่ม/แก้ไข หน่วยงานผู้ใช้</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        {this.state.departmentMap.item && (<div className="modal-body">
                            <div className="rrs-detail-data sp-table-container">
                                <div id="div_UserInfo" className="rrs-detail">

                                    <div className="rrs-detail pt-2 pb-3 px-3 item-information">
                                        
                                        <div className="row">
                                            <div className="col-md-1"></div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="unitCode" className="rrs-label"><span className="required">*</span> หน่วยงานผู้สร้างข้อมูล (Creator)</label>
                                                    <div className="rrs-detail-data">
                                                        <DropDownList
                                                            key={`itemModal_${departmentMap.item.create_Department}`}
                                                            name="create_Department"
                                                            options={this.setOrg_Unit()}
                                                            onSelectChanged={this.handleChange}
                                                            selected={departmentMap.item.create_Department}
                                                            doctype={this.state.docType}
                                                            className="create_Department"
                                                            tagid="department.create_Department"
                                                            disabled={roleAdmin ? false : true}
                                                        >
                                                        </DropDownList>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="sapUser" className="rrs-label"><span className="required">*</span> หน่วยงานจัดหา (Reviewer)</label>
                                                    <div className="rrs-detail-data">
                                                        <DropDownList
                                                            key={`itemModal_${departmentMap.item.reviewer_Department}`}
                                                            name="reviewer_Department"
                                                            options={this.setUnitReviewer()}
                                                            onSelectChanged={this.handleChange}
                                                            selected={departmentMap.item.reviewer_Department}
                                                            doctype={this.state.docType}
                                                            className="reviewer_Department"
                                                            tagid="department.reviewer_Department"
                                                            disabled={roleAdmin ? false : true}
                                                        >
                                                        </DropDownList>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="rrs-form">
                                                    <label htmlFor="sapUser" className="rrs-label"><span className="required">*</span> สถานะ</label>
                                                    <div className="rrs-detail-data">
                                                    <div className="row">
                                                            <div className="col-md-4">
                                                                <label className="radiocontainer">ใช้งาน
                                                                    <input
                                                                        type="radio"
                                                                        name="Active"
                                                                        value={true}
                                                                        checked={(departmentMap.item.isActive === true )}
                                                                        onChange={this.handleChange} 
                                                                        disabled={roleAdmin ? false : true}/>
                                                                    <span className="checkmark" />
                                                                </label>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <label className="radiocontainer">ไม่ใช้งาน
                                                                    <input
                                                                        type="radio"
                                                                        name="InActive"
                                                                        value={false}
                                                                        checked={(departmentMap.item.isActive === false)}
                                                                        onChange={this.handleChange}  
                                                                        disabled={roleAdmin ? false : true}/>
                                                                    <span className="checkmark" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="rrs-detail py-1">
                                    <div className="row sp-table-content-footer">
                                        <div className="col-10 sp-header-button-panel2"></div>
                                        <div className="col-2 sp-header-button-panel2">
                                            <a href="#" className="sp-btn-icon btn-del" data-dismiss="modal">
                                                <i className="icon btn-order-delete" />
                                                <span className="sp-btn-icon-label">Close</span>
                                            </a>
                                            <a href="#departmentmap" className="sp-btn-icon" onClick={() => this.saveDepartmentMap()} style={{ display: roleAdmin ? "" : "none" }}>
                                                <i className="icon btn-order-savedraft" />
                                                <span className="sp-btn-icon-label">Save</span>
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    </div>
                </div>
            </div >
        )

    }
}

const mapStateToProps = state => {
    const { MasterRedux, DepartmentMapRedux } = state
    return {
        org_unit: MasterRedux.org_unit,
        unitreviewerAll : DepartmentMapRedux.unitreviewerAll,
        departmapModal : DepartmentMapRedux.departmapModal,
        departmapAll : DepartmentMapRedux.departmapAll,
        isSuccess : DepartmentMapRedux.isSuccess,
        departmaperrorMsg : DepartmentMapRedux.departmaperrorMsg

    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateUser: (data) => dispatch(updateUserAction(data)),
        updateUserModal: (data) => dispatch(updateUserModalAction(data)),
        clearErrorMsg: () => dispatch(clearErrorMsgAction()),
        getAllOrgUnits: () => dispatch(getAllOrgUnitsAction()),
        getAllUnitReviewer: () => dispatch(getAllUnitReviewerAction()),
        createDeartmentMap: (data) => dispatch(createDeartmentMapAction(data)),
        updateDeartmentMap: (data) => dispatch(updateDeartmentMapAction(data))

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DepartmentMapModal)